import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_15} from 'styles/FontConstants';
import {REGRESSION_TYPE_TO_READABLE} from 'ui-library/charting/statistics/regression/Constants';
import {RegressionType} from 'ui-library/charting/statistics/regression/RegressionTypes';
import {GRAY_DARKER, GRAY_LIGHTER} from 'ui-library/Colors';
import {Title} from 'ui-library/Headers';
import LatexEquation, {EquationDisplayMode} from 'ui-library/LatexEquation';
import Link from 'ui-library/Link';

import {ConfigModalSupportedRegressionTypes} from './RegressionConfigModal';

export const REGRESSION_TYPE_TO_FIT_FN: {[key in ConfigModalSupportedRegressionTypes]: string} = {
  [RegressionType.LOGISTIC]: String.raw`Y = \text{min} + \frac{\text{max} - \text{min}}{1+(\text{IC50}/X)^\text{slope}}`,
};

export default function RegressionConfigModalModelSection(props: {
  regressionType: RegressionType.LOGISTIC;
}): JSX.Element {
  return (
    <>
      <Title>Model</Title>
      <p>{REGRESSION_TYPE_TO_READABLE[props.regressionType]}</p>
      <div className={css(styles.descriptionWrapper, styles.proxima15)}>
        <LatexEquation
          displayMode={EquationDisplayMode.BLOCK}
          equation={REGRESSION_TYPE_TO_FIT_FN[props.regressionType]}
        />
      </div>
      <Title className="u-small-spacing-top">Fitting algorithm</Title>
      <p>Least squares</p>
      <div className={css(styles.descriptionWrapper)}>
        <Link
          href="https://docs.scipy.org/doc/scipy/reference/generated/scipy.optimize.leastsq.html"
          target="_new"
        >
          See details
        </Link>{' '}
        on how the regression is calculated using the least squares fitting algorithm.
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  proxima15: FONT_PROXIMA_15,
  descriptionWrapper: {
    backgroundColor: GRAY_LIGHTER,
    borderRadius: 4,
    color: GRAY_DARKER,
    marginBottom: 20,
    padding: '8px 8px 8px 16px',
  },
});
